import { Loader2 } from "lucide-react";
import { statusOf } from "@/lib/files";
import { cn } from "@/lib/utils";

const TONES = {
  ok: "border-emerald-400/20 bg-emerald-400/[0.07] text-emerald-200",
  busy: "border-white/10 bg-white/[0.04] text-zinc-300",
  error: "border-rose-400/25 bg-rose-500/[0.07] text-rose-200",
  muted: "border-white/10 bg-transparent text-zinc-400",
};

export function FileStatusBadge({ file, className }) {
  const { label, tone } = statusOf(file);
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px]", TONES[tone], className)} data-testid="file-status-badge" data-status={file?.status}>
      {tone === "busy" && <Loader2 className="h-3 w-3 animate-spin" />}
      {label}
    </span>
  );
}
